import { render, staticRenderFns } from "./SupportTickets.vue?vue&type=template&id=b9bec88e&scoped=true"
import script from "./SupportTickets.vue?vue&type=script&lang=js"
export * from "./SupportTickets.vue?vue&type=script&lang=js"
import style0 from "./SupportTickets.vue?vue&type=style&index=0&id=b9bec88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bec88e",
  null
  
)

export default component.exports